import { Suspense, lazy } from "react"
import { Toaster } from "@/components/ui/toaster"
import { Toaster as Sonner } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"

// Lazy load pages for code splitting
const Index = lazy(() => import("./pages/Index"))
const Post = lazy(() => import("./pages/Post"))
const Journalctl = lazy(() => import("./pages/Journalctl"))
const Contact = lazy(() => import("./pages/Contact"))
const Portfolio = lazy(() => import("./pages/Portfolio"))
const NotFound = lazy(() => import("./pages/NotFound"))

// Create a client with improved settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Router>
        <div className="min-h-screen bg-background text-foreground">
          <Suspense
            fallback={
              <div className="flex items-center justify-center min-h-screen">
                <p className="text-muted-foreground animate-dots">Loading</p>
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/post/:id" element={<Post />} />
              <Route path="/journalctl" element={<Journalctl />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </TooltipProvider>
  </QueryClientProvider>
)

export default App
